import React from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import classNames from 'classnames';

import Tippy from '../utils/Tippy';
import Icon, { ClipboardIcon } from '../utils/icons';

import ANALYSED_CHAT_LIST_QUERY from '../routes/chats/analysed/AnalysedChatList';

const CHAT_QUERY = gql`
  query Chat($id: Int!) {
    chat(id: $id) {
      id
      status
      messages {
        id
        text
        sender
        source
        sent
      }
      created
    }
  }
`;

const NEW_CHAT_LIST_QUERY = gql`
  {
    newChats {
      id
      messages {
        id
        text
        sender
        source
        sent
      }
      created
    }
  }
`;

const ANALYSE_CHAT_MUTATION = gql`
  mutation analyseChat($session: Int!) {
    analyseChat(session: $session)
  }
`;

const AnalyseChatButton = ({ chatId, active }) => {
  const classes = classNames({
    'chat-info-header-action': true,
    'chat-info-header-action-analyse': true,
    'chat-info-header-action-analyse-active': active,
  });

  if (active) {
    return (
      <div className={classes}>
        <Icon icon={ClipboardIcon} className="chat-info-header-action-icon" />
      </div>
    );
  }

  return (
    <Mutation
      mutation={ANALYSE_CHAT_MUTATION}
      refetchQueries={() => {
        return [
          {
            query: CHAT_QUERY,
            variables: { id: chatId },
          },
          {
            query: NEW_CHAT_LIST_QUERY,
          },
        ];
      }}
    >
      {(analyseChat, { loading, error, data }) => (
        <div
          className={classes}
          onClick={e => {
            e.preventDefault();

            if (!loading && !active) {
              analyseChat({ variables: { session: chatId } });
            }
          }}
        >
          <Icon icon={ClipboardIcon} className="chat-info-header-action-icon" />
        </div>
      )}
    </Mutation>
  );
};

export default AnalyseChatButton;
